// extracted by mini-css-extract-plugin
module.exports = {"customTextForm":"CustomTextForm_customTextForm__3QKrL"};